import axios from 'axios'

import { getBaseUrl } from 'utils/baseUrls'

const GREMLIN_AGENT = `website/${process.env.NODE_ENV}`

const baseURL = `${getBaseUrl('api')}/v1`
const agent = axios.create({
  baseURL,
  adapter:
    process.env.NODE_ENV === 'test'
      ? require('axios/lib/adapters/http')
      : require('axios/lib/adapters/xhr')
})

function bootstrapAgent() {
  // When using hot reloading, interceptors do not get cleared. Therefore after
  // a few reloads requests will behave erratically as they're being caught
  // multiple times.
  agent.interceptors.request.handlers = []
  agent.interceptors.response.handlers = []

  agent.interceptors.request.use(function (config) {
    config.headers['X-Gremlin-Agent'] = GREMLIN_AGENT
    return config
  })
}

export { agent, bootstrapAgent }
export default agent
